import GireApi from '../utils/gire_api';
import jwt_decode from 'jwt-decode';

const SetConnectAuthToken = (type, token) => {
    console.log(type, token);
    if (type === "GIRE" && (token && token.length)) {
        localStorage.setItem('gire_token', token);
        const decoded = jwt_decode(localStorage.gire_token) && jwt_decode(localStorage.gire_token);
        GireApi.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        GireApi.defaults.headers.common['user_id'] = parseInt(decoded&&decoded.uid);
    }else {
        // delete GireApi.defaults.headers.common['Authorization'];
        // delete GireApi.defaults.headers.common['user_id'];
        // localStorage.removeItem('gire_token');

    }
};

export default SetConnectAuthToken;